import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { agencyPointsConvertService } from "../../services/agency-points-convert";
import { AGENCY_FIRST_QUERY_KEY } from "../agencies/use-get-agency-first";
import { AGENCIES_SALES_DETAILS_QUERY_KEY } from "../agencies-sales-details/use-get-agencies-sales-details";
import { useGetMyProfile } from "../profile/use-get-my-profile";

export const AGENCY_POINTS_CONVERT_QUOTE_QUERY_KEY = "getAgencyPointsConvertQuote";

export const useAgencyPointsConvertQuote = () => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: [AGENCY_POINTS_CONVERT_QUOTE_QUERY_KEY],
    queryFn: () => agencyPointsConvertService.getQuote(),
  });

  return {
    quote: data?.status === "success" ? data.data : null,
    error: data?.status === "error" ? data.error : null,
    isLoading,
    refetch,
  };
};

export const useConvertAgencyPointsToCoins = () => {
  const { invalidate } = useGetMyProfile();
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: agencyPointsConvertService.convert,
    onSettled: () => {
      // balances changed: quote, profile (Coins Trading card) and agency cache
      invalidate();
      queryClient.invalidateQueries({
        queryKey: [AGENCY_POINTS_CONVERT_QUOTE_QUERY_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [AGENCY_FIRST_QUERY_KEY],
        exact: false,
      });
      // the history lists conversions too
      queryClient.invalidateQueries({
        queryKey: [AGENCIES_SALES_DETAILS_QUERY_KEY],
        exact: false,
      });
    },
  });

  return { convert: mutateAsync, isLoading: isPending };
};
